import React, { useState } from "react";
import S2aReport from "./S2aReport";
import S2bReport from "./S2bReport";
import S2cReport from "./S2cReport";
import S2dReport from "./S2dReport";
import S2eReport from "./S2eReport";

type TabType = "s2a" | "s2b" | "s2c" | "s2d" | "s2e";

const S2ReportPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>("s2a");

  const tabs = [
    {
      id: "s2a" as TabType,
      label: "S2a - Doanh thu bán HH, DV",
      description: "Sổ doanh thu đơn giản",
    },
    {
      id: "s2b" as TabType,
      label: "S2b - DT theo ngành nghề",
      description: "Doanh thu nhóm theo ngành nghề",
    },
    {
      id: "s2c" as TabType,
      label: "S2c - Doanh thu, chi phí",
      description: "Chi tiết doanh thu và chi phí",
    },
    {
      id: "s2d" as TabType,
      label: "S2d - Vật liệu, hàng hóa",
      description: "Nhập - xuất - tồn kho",
    },
    {
      id: "s2e" as TabType,
      label: "S2e - Chi tiết tiền",
      description: "Thu/gửi vào - Chi/rút ra",
    },
  ];

  return (
    <div className="p-6 space-y-6">
      <div>
        <p className="text-sm text-gray-500 uppercase">Báo cáo S2-HKD</p>
        <h1 className="text-2xl font-semibold text-gray-900">
          Sổ kế toán theo TT152
        </h1>
        <p className="text-sm text-gray-600 mt-1">
          Bao gồm 5 mẫu sổ: S2a (doanh thu), S2b (doanh thu theo ngành nghề),
          S2c (doanh thu - chi phí), S2d (vật liệu - hàng hóa), S2e (chi tiết
          tiền)
        </p>
      </div>

      {/* Tab Navigation */}
      <div className="border-b border-gray-200">
        <nav className="-mb-px flex space-x-4" aria-label="Tabs">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm
                ${
                  activeTab === tab.id
                    ? "border-blue-500 text-blue-600"
                    : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
                }
              `}
            >
              <div>
                <div>{tab.label}</div>
                <div className="text-xs font-normal mt-0.5 text-gray-500">
                  {tab.description}
                </div>
              </div>
            </button>
          ))}
        </nav>
      </div>

      {/* Tab Content */}
      <div className="mt-6">
        {activeTab === "s2a" && <S2aReport />}
        {activeTab === "s2b" && <S2bReport />}
        {activeTab === "s2c" && <S2cReport />}
        {activeTab === "s2d" && <S2dReport />}
        {activeTab === "s2e" && <S2eReport />}
      </div>
    </div>
  );
};

export default S2ReportPage;
